<!--活动表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            生成兑换码
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="8vw" class="pb-6" label-position="top">
                <el-form-item label="优惠券" :rules="[{ required: true }]">
                    <el-select
                        v-model="form.template_id"
                        clearable
                        placeholder="请选择"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in coupons"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生成兑换码数量" :rules="[{ required: true }]">
                    <el-input-number
                        v-model="form.count"
                        controls-position="right"
                        :min="1"
                    ></el-input-number>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
Date.prototype.Format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};
import { mapState } from "vuex";
import util from "@/util";
import store from "@/store";
import Public from "@/public";
export default {
    name: "ActivityForm",
    data() {
        return {
            form: {
                count: null, //领取优惠卷张数
                template_id: null, //优惠卷ID
            },
            coupons: [],
        };
    },
    created() {
        this.getCoupon();
    },
    computed: {
        ...mapState(["theme", "couponInfos"]),
    },
    methods: {
        /*获取优惠券*/
        async getCoupon() {
            let params = {
                postData: {},
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getCoupon", params);
            let datas = this.JsonData(this.couponInfos);
            let arr = [];
            for (let i = 0; i < datas.length; i++) {
                arr[i] = {
                    value: datas[i].id,
                    label: datas[i].name,
                };
            }
            this.coupons = this.JsonData(arr);
        },
        /*确定*/
        determine() {
            let that = this;
            let params = {
                postData: {},
                callback: () => {
                    this.cancel();
                },
                callbackOk: data => {
                    // console.log(data);
                    const T_URL = window.URL.createObjectURL(new Blob([data]));
                    const LINK = document.createElement("a");
                    LINK.href = T_URL;
                    LINK.setAttribute(
                        "download",
                        "优惠券兑换码(" +
                            Public.longDataToStr2(new Date().getTime()) +
                            ")(数量：" +
                            that.form["count"] +
                            ")" +
                            ".txt"
                    );
                    LINK.click();
                    window.URL.revokeObjectURL(T_URL);
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            if (!form["template_id"] || !form["count"]) {
                util.ShowTip("必填项不能为空", 3);
                return;
            }
            params.postData = Object.assign({}, form);
            console.log(params);
            store.dispatch("generateRedeem", params);
        },
        /*取消*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = null;
            });
            this.$emit("cancel");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
